module.exports = __webpack_public_path__ + "static/media/49_B.77283480.png";